import slimvue from "slimvue";
import App from "./App.vue";
import px2rem from "./utils/px2rem";
slimvue.mount(App);
px2rem();
